import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOOdontologyTissueType } from "../models/odo/BOOdontologyTissueType.model";
import { BOPayTypeSellDetail } from "../models/BOPayTypeSellDetail.model";

@Injectable({
  providedIn: 'root'
})

export class PayTypeSellDetailService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/PayTypeSellDetail/';

    constructor(private http:HttpClient){}

    getAllPayTypeByPatientId(patientId:number):Observable<BOPayTypeSellDetail[]>{
        return this.http.get<BOPayTypeSellDetail[]>(this.myAppUrl + this.myApiUrl+'getAllPayTypeByPatientId/'+patientId);
    }
    getAllPayTypeByPatientIdString(patientIdString:string):Observable<BOPayTypeSellDetail[]>{
        return this.http.get<BOPayTypeSellDetail[]>(this.myAppUrl + this.myApiUrl+'getAllPayTypeByPatientIdString/'+patientIdString);
    }

  }
